<script>
    import { countryRegionService } from '../../../common/service/resource';
    import BrasilidadeMap from './BrasilidadeMap';
    import CountryRegion from '../country-region/CountryRegion';
    import CountryRegionProducts from '../country-region/CountryRegionProducts';
    import CountryRegionPartners from '../country-region/CountryRegionPartners';
    import CountryRegionBlogPosts from '../country-region/CountryRegionBlogPosts';
    import CountryRegionPodcasts from '../country-region/CountryRegionPodcasts';
    import VueRouter from 'vue-router';
    import CountryRegionHome from '../country-region/CountryRegionHome';
    import BrasilidadeIntro from './BrasilidadeIntro';
    import Spinner from '../../../../../submodules/src/components/feedback/spinner/Spinner.vue';
    import general from '../../i18n/general';
    import locale from '../../i18n/locale';

    const routes = [
        {
            name: 'home',
            path: '/brasilidade',
            component: BrasilidadeIntro,
        },
    ];

    routes.push(
        ...['centro-oeste', 'nordeste', 'norte', 'sudeste', 'sul'].map((r) => ({
            path: `/brasilidade/${r}`,
            component: CountryRegion,
            props: () => ({ regionName: r }),
            children: [
                {
                    name: `${r}-home`,
                    path: '',
                    component: CountryRegionHome,
                },
                {
                    name: `${r}-products`,
                    path: 'produtos',
                    component: CountryRegionProducts,
                },
                {
                    name: `${r}-collections`,
                    path: 'colecoes',
                    component: CountryRegionPartners,
                },
                {
                    name: `${r}-blog`,
                    path: 'blog',
                    component: CountryRegionBlogPosts,
                },
                {
                    name: `${r}-podcasts`,
                    path: 'podcasts',
                    component: CountryRegionPodcasts,
                },
            ],
        }))
    );

    const router = new VueRouter({
        mode: 'history',
        base: '/',
        routes,
        scrollBehavior(to, from, savedPosition) {
            if ((to.name === 'orders' || to.name === 'new-exchange') && from.name === to.name)
                return null;

            if (savedPosition) {
                return savedPosition;
            } else {
                return { x: 0, y: 0 };
            }
        },
    });

    export default {
        name: 'BrasilidadePage',

        el: '#brasilidade-vue',

        i18n: locale(general()),

        router,

        components: {
            'brasilidade-map': BrasilidadeMap,
            'brasilidade-intro': BrasilidadeIntro,
            spinner: Spinner,
        },

        data() {
            return {
                regions: null,
            };
        },

        created() {
            this.fetchRegions();
        },

        methods: {
            fetchRegions() {
                countryRegionService
                    .query()
                    .then((response) => (this.regions = response.data.data));
                // todo catch
            },
        },
    };
</script>
